import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { createSpecialistConfigs } from '../utils/config';
import { developerMapper } from '../utils/mapper';
import { MIN_SPECIALISTS_COUNT } from '../constants';
import {
  selectAgenciesData,
  selectDevelopersData,
  selectRealtorsData,
  selectRegionsData,
  selectUrlsData,
} from '../../../selectors/mainpage';

export const useSpecialists = (section: string) => {
  const realtorsData = useSelector(selectRealtorsData);
  const agenciesData = useSelector(selectAgenciesData);
  const developersData = useSelector(selectDevelopersData);
  const regionsData = useSelector(selectRegionsData);
  const urls = useSelector(selectUrlsData);

  const developersTitle = useMemo(() => {
    if (section !== 'new-buildings') {
      return 'Застройщики';
    }

    return regionsData.subdomainRegionAllowed
      ? `Застройщики ${regionsData.subdomainRegionInflectedTitleLoct}`
      : 'Застройщики в Москве';
  }, [section, regionsData]);

  const developersArray = useMemo(() => developersData?.map(developerMapper) || null, [developersData]);

  const specialists = useMemo(() => {
    const configs = createSpecialistConfigs({
      realtorsData,
      agenciesData,
      developersArray,
      developersTitle,
      developersUrl: urls.developers,
    });

    return configs.filter(
      specialist => specialist.specialists && specialist.specialists.length > MIN_SPECIALISTS_COUNT,
    );
  }, [realtorsData, agenciesData, developersArray, developersTitle, urls.developers]);

  return specialists;
};
